import request from '@/sheep/request';

const DistributorApi = {
  // 获取分销二维码
  getQrCode: (position) => {
    return request({
      url: '/operation/distributor/qr-code',
      method: 'GET',
      params: {
        position,
      },
      custom: {
        showError: false,
        showLoading: false,
      },
    });
  },
  // 获取分销员自己的订单统计
  getOrderStatistics: () => {
    return request({
      url: '/operation/distributor/order/my-statistics',
      method: 'GET',
      custom: {
        showError: false,
        showLoading: false,
      },
    });
  },
  // 获取分销员自己的订单列表
  getOrderList: (params) => {
    return request({
      url: '/operation/distributor/order/my-page',
      method: 'GET',
      params,
      custom: {
        showError: false,
        showLoading: false,
      },
    });
  },
  // 获取下级分销员的订单统计
  getSubOrderStatistics: () => {
    return request({
      url: '/operation/distributor/order/sub-statistics',
      method: 'GET',
      custom: {
        showError: false,
        showLoading: false,
      },
    });
  },
  // 获取下级分销员的订单列表
  getSubOrderList: (params) => {
    return request({
      url: '/operation/distributor/order/sub-page',
      method: 'GET',
      params,
      custom: {
        showError: false,
        showLoading: false,
      },
    });
  },
  // 获取下级分销员统计
  getSubordinateStatistics: () => {
    return request({
      url: '/operation/distributor/subordinate/statistics',
      method: 'GET',
      custom: {
        showError: false,
        showLoading: false,
      },
    });
  },
  // 获取下级分销员列表
  getSubordinateList: (params) => {
    return request({
      url: '/operation/distributor/subordinate/page',
      method: 'GET',
      params,
      custom: {
        showError: false,
        showLoading: false,
      },
    });
  },
};

export default DistributorApi;